<template>
  <transition name="el-popover-fade" @after-enter="afterEnter" @after-leave="afterLeave">
    <div
      v-if="visible"
      class="el-popover__container"
      :class="visible && 'el-popover__open'"
      role="document"
      tabindex="-1"
      :style="popoverStyle"
    >
      <section class="el-popover__body">
        <slot></slot>
      </section>
      <div class="page-layout-sets page-layout-sets-more new-btn-groups popper-setting" @click.stop>
        <div class="set-groups-wrap">
          <div class="set-groups base-set-groups">
            <i class="icon icon-portal-icon_popover"></i>
            <span>弹出框</span>
          </div>
        </div>
        <div class="set-groups-wrap">
          <div class="set-groups handle-btn-name" @click.stop="closePopper">
            <span class="icon icon-portal-preview-close-one1"></span>
          </div>
          <span class="line"></span>
          <div class="set-groups handle-btn-name" @click.stop="openEditor">
            <span class="icon icon-portal-setting1"></span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "cxPopover",
  props: {
    appendToBody: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: "top"
    },
    visible: {
      type: Boolean
    },
    customeStyle: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    },
    zoom: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      closed: false,
      prevActiveElement: null,
      ownStyle: {
        position: "fixed",
        top: -1000,
        left: -1000
      }
    }
  },
  computed: {
    popoverStyle() {
      return { ...this.customeStyle, ...this.ownStyle }
    },
    spacing() {
      return this.options.popoverParams.spacing
    },
    spacingH() {
      return this.options.popoverParams.spacingH
    },
    width() {
      return this.options.popoverParams.width
    },
    height() {
      return this.options.popoverParams.height
    },
    showLeftMenus() {
      return this.$store.state.states.showLeftMenus
    },
    showRightToolbar() {
      return this.$store.state.states.showRightToolbar
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.closed = false
        this.$emit("open")
        if (this.appendToBody) {
          document.body.appendChild(this.$el)
        }
        this.computePosition()
        this.prevActiveElement = document.activeElement
        this.scrollWrap.addEventListener("scroll", this.scrollHandler)
        const sourceDom = document.querySelector(`.${this.options.source_id}`)
        if (!sourceDom) {
          return
        }
        this.observer = new MutationObserver(() => {
          this.scrollHandler()
        })
        this.observer.observe(sourceDom, {
          attributes: true,
          attributeFilter: ["style"]
        })
      } else {
        if (!this.closed) {
          this.$emit("close")
        }
        this.$nextTick(() => {
          if (this.prevActiveElement) {
            this.prevActiveElement.focus()
          }
        })
        this.scrollWrap.removeEventListener("scroll", this.scrollHandler)
        this.observer.disconnect()
        this.observer = null
      }
    },
    placement() {
      this.computePosition()
    },
    spacing() {
      this.computePosition()
    },
    spacingH() {
      this.computePosition()
    },
    width() {
      this.computePosition()
    },
    height() {
      this.computePosition()
    },
    showLeftMenus() {
      setTimeout(() => {
        this.computePosition()
      }, 200)
    },
    showRightToolbar() {
      setTimeout(() => {
        this.computePosition()
      }, 200)
    }
  },
  methods: {
    afterEnter() {
      this.$emit("opened")
    },
    afterLeave() {
      this.$emit("closed")
    },
    closePopper() {
      this.$emit("update:visible", false)
      this.$emit("close")
      this.closed = true
    },
    computePosition() {
      this.sourceDom = this.sourceDom ?? document.querySelector(`.${this.options.source_id}`)
      if (!this.sourceDom) {
        return
      }
      const { top, right, bottom, left } = this.sourceDom.getBoundingClientRect()
      let style = { position: "fixed" }
      let { width: popWidth, height: popHeight, spacing = 0, spacingH = 0 } = this.options.popoverParams
      popWidth *= this.zoom
      popHeight *= this.zoom
      spacing *= this.zoom
      spacingH *= this.zoom
      switch (this.placement) {
        case "top-start":
          style.top = `${top - popHeight - spacing}px`
          style.left = `${left + spacingH}px`
          break
        case "top":
          style.top = `${top - popHeight - spacing}px`
          style.left = `${left - (popWidth - (right - left)) / 2 + spacingH}px`
          break
        case "top-end":
          style.top = `${top - popHeight - spacing}px`
          style.left = `${left - (popWidth - (right - left)) + spacingH}px`
          break
        case "bottom-start":
          style.top = `${bottom + spacing}px`
          style.left = `${left + spacingH}px`
          break
        case "bottom":
          style.top = `${bottom + spacing}px`
          style.left = `${left - (popWidth - (right - left)) / 2 + spacingH}px`
          break
        case "bottom-end":
          style.top = `${bottom + spacing}px`
          style.left = `${left - (popWidth - (right - left)) + spacingH}px`
          break
        case "left-start":
          style.top = `${top + spacing}px`
          style.left = `${left - popWidth - spacingH}px`
          break
        case "left":
          style.top = `${top - (popHeight - (bottom - top)) / 2 + spacing}px`
          style.left = `${left - popWidth - spacingH}px`
          break
        case "left-end":
          style.top = `${bottom - popHeight + spacing}px`
          style.left = `${left - popWidth - spacingH}px`
          break
        case "right-start":
          style.top = `${top + spacing}px`
          style.left = `${right + spacingH}px`
          break
        case "right":
          style.top = `${top - (popHeight - (bottom - top)) / 2 + spacing}px`
          style.left = `${right + spacingH}px`
          break
        case "right-end":
          style.top = `${bottom - popHeight + spacing}px`
          style.left = `${right + spacingH}px`
          break
      }
      this.ownStyle = style
    },
    scrollHandler() {
      this.computePosition()
    },
    openEditor() {
      this.$store.commit("states/changeShowRightToolbarStatus", true)
      this.$store.commit("states/changeActiveID", this.options.sourceIds)
      this.$store.commit("states/changeElementType", "cxButton")
    }
  },
  mounted() {
    if (this.visible) {
      if (this.appendToBody) {
        document.body.appendChild(this.$el)
      }
    }
    this.scrollWrap = document.querySelector("#pageScollbar .el-scrollbar__wrap")
    window.addEventListener("resize", this.computePosition)
  },
  destroyed() {
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
    this.scrollWrap.removeEventListener("scroll", this.scrollHandler)
    this.scrollWrap = null
    window.removeEventListener("resize", this.computePosition)
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    this.sourceDom = null
  }
}
</script>

<style lang="scss" scoped>
.popper-setting {
  position: absolute;
  top: -38px;
  .line {
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    width: 1px;
    background-color: rgba(233, 233, 233, 1);
    margin: 0 2px;
  }
}
</style>
